import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { useEventBasicInformationContext } from '../../../../../contexts';
import type { LocalizedDateTime } from '../../../../../types';
import { getFormattedDateWithTz } from '../../../../utils/localizedDates';
import styles from './CondensedConversionBar.module.scss';

type CondensedConversionBarProps = {
    startDateTime?: LocalizedDateTime;
    priceTag: string;
    checkoutButton: React.ReactNode;
    isOnline?: boolean;
    locale: string;
};

const formatDate = (
    date: LocalizedDateTime,
    locale: string,
    isOnline: boolean,
) => {
    return getFormattedDateWithTz({
        date,
        formatString: 'MMM d',
        locale: locale,
        isOnlineEvent: isOnline,
    });
};

const formatTime = (
    date: LocalizedDateTime,
    locale: string,
    isOnline: boolean,
) => {
    return getFormattedDateWithTz({
        date,
        formatString: 'p zzz',
        locale: locale,
        isOnlineEvent: isOnline,
    });
};

export const CondensedConversionBar: React.FC<CondensedConversionBarProps> = ({
    startDateTime,
    priceTag,
    checkoutButton,
    isOnline = false,
    locale,
}) => {
    const { hideStartDate } = useEventBasicInformationContext();
    return (
        <div className={styles.wrapper}>
            <div className={styles.dateAndPriceWrapper}>
                <span className={styles.priceTag}>{priceTag}</span>
                {hideStartDate ? (
                    <span>{gettext('Date to be scheduled')}</span>
                ) : (
                    startDateTime && (
                        <span>
                            {gettext('%(date)s · %(time)s', {
                                date: formatDate(
                                    startDateTime,
                                    locale,
                                    isOnline,
                                ),
                                time: formatTime(
                                    startDateTime,
                                    locale,
                                    isOnline,
                                ),
                            })}
                        </span>
                    )
                )}
            </div>
            <div className={styles.checkoutButtonWrapper}>{checkoutButton}</div>
        </div>
    );
};
